import { GET_FIREWALL_CONFIG, GET_ALL_IPS_BLOCKED } from './mutation-types'

import firewallHttpService from '../_services/firewallHttpService'

export default {
  listarConfiguracoesFirewall: async ({ commit }) => {
    try {
      const response = await firewallHttpService.getFirewallConfig()
      commit(GET_FIREWALL_CONFIG, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarIpsBloqueados: async ({ commit }) => {
    try {
      const response = await firewallHttpService.getIpsBlocked()
      commit(GET_ALL_IPS_BLOCKED, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
